import React from "react";

import {
    IOptionCode,
    IOptionSingleValue,
    IProduct,
} from "../models/catalogue.interfaces";
import { SelectOptions } from "./SelectOptions";

interface IProps {
    variant: IProduct | null;
    code: IOptionCode;
    value: IOptionSingleValue;
    options: IOptionSingleValue[];
    prefixNameCapped: string;
    configuratorClass: string;
    prefixClass: string;
    selectClass: string;
    onChange: (event: React.FormEvent<HTMLSelectElement>) => void;
}

const buildSwatch = (
    variant: IProduct | null,
    code: IOptionCode = "option_color_hex",
): React.ReactNode => {
    if (!variant) {
        return;
    }
    const attr = variant.attributes[code];
    if (!attr) {
        return;
    }
    const colorHex = attr.value;
    if (!colorHex) {
        return;
    }
    const swatchStyle: React.CSSProperties = {
        backgroundColor: `#${colorHex}`,
    };
    return (
        <div className="configurator__color-swatch" style={swatchStyle}></div>
    );
};

export const ProductOptionColorSelector = (props: IProps): React.ReactNode => {
    return (
        <div>
            <div className="configurator__select-container configurator__select-container--swatch configurator__color-swatch-container">
                {buildSwatch(props.variant)}
            </div>
            <div className={props.configuratorClass}>
                <span className={props.prefixClass}>
                    {props.prefixNameCapped}:
                </span>
                <select
                    value={props.value}
                    name={props.code}
                    onChange={props.onChange}
                    className={props.selectClass}
                >
                    <optgroup label={props.prefixNameCapped}>
                        <SelectOptions options={props.options} />
                    </optgroup>
                </select>
            </div>
        </div>
    );
};
